export const FareCalculator = (distance, time, rateDetails, instructionData, decimal) => {
    const dec = decimal !== undefined && decimal !== null ? parseInt(decimal) : 2;

    let baseCalculated = (parseFloat(rateDetails.rate_per_unit_distance) * parseFloat(distance)) +
        (parseFloat(rateDetails.rate_per_hour) * (parseFloat(time) / 3600));

    if (parseFloat(rateDetails.base_fare) > 0) {
        baseCalculated = baseCalculated + parseFloat(rateDetails.base_fare);
    }

    if (instructionData && instructionData.parcelTypeSelected) {
        baseCalculated = baseCalculated + parseFloat(instructionData.parcelTypeSelected.amount);
    }

    if (instructionData && instructionData.optionSelected) {
        baseCalculated = baseCalculated + parseFloat(instructionData.optionSelected.amount);
    }

    let minFare = parseFloat(rateDetails.min_fare);
    let total = baseCalculated > minFare ? baseCalculated : minFare;

    let convenienceFee = 0;
    let convRate = parseFloat(rateDetails.convenience_fees);

    if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type === 'flat') {
        convenienceFee = convRate;
    } else {
        convenienceFee = (total * convRate / 100);
    }

    let grand = total + convenienceFee;

    return {
        totalCost: parseFloat(total.toFixed(dec)),
        grandTotal: parseFloat(grand.toFixed(dec)),
        convenience_fees: parseFloat(convenienceFee.toFixed(dec))
    }
}
